// One place that turns a firm's Billing Settings address fields into the single
// address string printed on every document (Invoice, Receipt, Credit Note,
// Quotation, Payslip, ...) — so they can never disagree with each other or with
// the live preview in Billing Settings.
//
// Accepts either the settings row (firm_address, firm_address2, firm_city,
// firm_state, firm_pincode) or an invoice-shaped row where the address line is
// aliased as firm_full_address.
//
// City / State / Pincode live in their own fields and are appended
// automatically — but a user may also have typed them into Address Line 1/2.
// Any part already present in the typed lines is NOT appended again, so the
// printed address never repeats "Lucknow, 226010".

const flat = (v) => String(v ?? '')
  .replace(/\s*[\r\n]+\s*/g, ', ')
  .replace(/\s+/g, ' ')
  .replace(/(,\s*)+/g, ', ')
  .replace(/^[,\s]+|[,\s]+$/g, '')
  .trim();

const norm = (v) => String(v ?? '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

function fields(s = {}) {
  return {
    line1: flat(s.firm_full_address ?? s.firm_address),
    line2: flat(s.firm_address2),
    city: flat(s.firm_city),
    state: flat(s.firm_state),
    pincode: flat(s.firm_pincode),
  };
}

// Which of City / State / Pincode are already written inside Address Line 1/2.
export function addressOverlap(s) {
  const f = fields(s);
  const typed = ` ${norm(`${f.line1} ${f.line2}`)} `;
  const hit = (val) => !!val && typed.includes(` ${norm(val)} `);
  const out = [];
  if (hit(f.city)) out.push('City');
  if (hit(f.state)) out.push('State');
  if (hit(f.pincode)) out.push('Pincode');
  return out;
}

export function buildFirmAddress(s) {
  const f = fields(s);
  const typed = ` ${norm(`${f.line1} ${f.line2}`)} `;
  const missing = (val) => !!val && !typed.includes(` ${norm(val)} `);

  const cityState = [missing(f.city) ? f.city : '', missing(f.state) ? f.state : ''].filter(Boolean).join(', ');
  const tail = [cityState, missing(f.pincode) ? f.pincode : ''].filter(Boolean).join(' - ');
  return [f.line1, f.line2, tail].filter(Boolean).join(', ');
}
